import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from '../../../common/api/http.service';
import {DataSource} from '@mominsamir/ngx-smart-table/lib/lib/data-source/data-source';
import {APIResponse, Filter} from '@core/interfaces/system/system-common';
import {LatestModelStatus} from '@core/interfaces/live/live';
import {HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {
    VegClearanceClearanceData,
    VegClearanceLastTrimData,
    VegClearanceUnits,
} from '@core/interfaces/live/veg-clearance';

@Injectable()
export class VegClearanceApi {
    private readonly PREFIX = 'live/output/veg-clearance';

    constructor(private api: HttpService) {}

    public getVegClearanceUnits(): Observable<VegClearanceUnits> {
        return this.api.get(`${this.PREFIX}/units`);
    }

    public getVegClearanceDatasource(id: string, filterss: Filter[]): Observable<DataSource> {
        return this.api.postServerDataSource(`${this.PREFIX}/list?filterByassetId=${id}`, filterss);
    }

    public getCountResults(assetId: string, uploadTime?: string): Observable<number> {
        return this.api
            .get(`${this.PREFIX}/count`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<number>) => res.response));
    }

    public getVegClearanceLatestModelStatus(assetId: string, uploadTime?: string): Observable<LatestModelStatus> {
        return this.api
            .get(`${this.PREFIX}/latest`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<LatestModelStatus>) => res.response));
    }

    public getVegClearanceClearanceData(assetId: string, uploadTime?: string): Observable<VegClearanceClearanceData> {
        return this.api
            .get(`${this.PREFIX}/data/clearance`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<VegClearanceClearanceData>) => res.response));
    }

    public getVegClearanceLastTrimData(assetId: string, uploadTime?: string): Observable<VegClearanceLastTrimData> {
        return this.api
            .get(`${this.PREFIX}/data/trim`, {
                params: new HttpParams().set('assetId', assetId || '').set('asOf', uploadTime || ''),
            })
            .pipe(map((res: APIResponse<VegClearanceLastTrimData>) => res.response));
    }
}
